export const SEARCH_HOO = 'SEARCH_HOO';
export const SET_SEARCH_HOO = 'SET_SEARCH_HOO';
export const SEARCH_HOO_SUCCESS = 'SEARCH_HOO_SUCCESS';
export const SEARCH_HOO_FAILED = 'SEARCH_HOO_FAILED';

export const FETCH_REQUESTORS = 'FETCH_REQUESTORS';
export const FETCH_REQUESTORS_SUCCESS = 'FETCH_REQUESTORS_SUCCESS';
export const FETCH_REQUESTORS_FAILURE = 'FETCH_REQUESTORS_FAILURE';

export const FETCH_LOCATIONS_FOR_REQUESTOR = 'FETCH_LOCATIONS_FOR_REQUESTOR';
export const FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS = 'FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS';
export const FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE = 'FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE';
export const FETCH_UNPLANNED_LOCATIONS = 'FETCH_UNPLANNED_LOCATIONS';
export const FETCH_UNPLANNED_LOCATIONS_SUCCESS = 'FETCH_UNPLANNED_LOCATIONS_SUCCESS';
export const FETCH_UNPLANNED_LOCATIONS_FAILURE = 'FETCH_UNPLANNED_LOCATIONS_FAILURE';

export const DELETE_HOO_REQUEST = 'DELETE_HOO_REQUEST';
export const DELETE_HOO_REQUEST_SUCCESS = 'DELETE_HOO_REQUEST_SUCCESS';
export const DELETE_HOO_REQUEST_FAILURE = 'DELETE_HOO_REQUEST_FAILURE';
export const SAVE_HOO_REQUEST = 'SAVE_HOO_REQUEST';
export const SAVE_HOO_REQUEST_SUCCESS = 'SAVE_HOO_REQUEST_SUCCESS';
export const SAVE_HOO_REQUEST_FAILED = 'SAVE_HOO_REQUEST_FAILED';

export const FETCH_REQUEST_REASONS = 'FETCH_REQUEST_REASONS';
export const FETCH_REQUEST_REASONS_SUCCESS = 'FETCH_REQUEST_REASONS_SUCCESS';
export const FETCH_REQUEST_REASONS_FAILURE = 'FETCH_REQUEST_REASONS_FAILURE';

export const FETCH_REQUEST_TYPES = 'FETCH_REQUEST_TYPES';
export const FETCH_REQUEST_TYPES_SUCCESS = 'FETCH_REQUEST_TYPES_SUCCESS';
export const FETCH_REQUEST_TYPES_FAILURE = 'FETCH_REQUEST_TYPES_FAILURE';

export const ACCEPT_HOO_REQUEST = 'ACCEPT_HOO_REQUEST';
export const ACCEPT_HOO_REQUEST_SUCCESS = 'ACCEPT_HOO_REQUEST_SUCCESS';
export const ACCEPT_HOO_REQUEST_FAILURE = 'ACCEPT_HOO_REQUEST_FAILURE';

export const REJECT_HOO_REQUEST = 'REJECT_HOO_REQUEST';
export const REJECT_HOO_REQUEST_SUCCESS = 'REJECT_HOO_REQUEST_SUCCESS';
export const REJECT_HOO_REQUEST_FAILURE = 'REJECT_HOO_REQUEST_FAILURE';

export const EXPORT_HOO_REQUESTS = 'EXPORT_HOO_REQUESTS';
export const EXPORT_HOO_REQUESTS_SUCCESS = 'EXPORT_HOO_REQUESTS_SUCCESS';
export const EXPORT_HOO_REQUESTS_FAILURE = 'EXPORT_HOO_REQUESTS_FAILURE';

export const setSearchHoo = (payload: any) => ({
  type: SET_SEARCH_HOO,
  payload,
});

export const searchHoo = (payload) => ({
  type: SEARCH_HOO,
  payload,
});

export const searchHooSuccess = (payload) => ({
  type: SEARCH_HOO_SUCCESS,
  payload,
});

export const searchHooFailed = (payload) => ({
  type: SEARCH_HOO_FAILED,
  payload,
});

export const fetchRequestors = (positions: string) => ({
  type: FETCH_REQUESTORS,
  payload: { positions },
});

export const fetchRequestorsSuccess = (requestors: any[], allData: any[]) => ({
  type: FETCH_REQUESTORS_SUCCESS,
  payload: { requestors, allData },
});

export const fetchRequestorsFailure = (error: any) => ({
  type: FETCH_REQUESTORS_FAILURE,
  payload: error,
});

export const fetchLocationsForRequestor = (contactSid: number, allData: any[], showAllLocations = false) => ({
  type: FETCH_LOCATIONS_FOR_REQUESTOR,
  payload: { contactSid, allData, showAllLocations },
});

export const fetchLocationsForRequestorSuccess = (locations: any[]) => ({
  type: FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS,
  payload: locations,
});

export const fetchLocationsForRequestorFailure = (error: any) => ({
  type: FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE,
  payload: error,
});

export const fetchUnplannedLocations = (positions = '', activeOnly = false) => ({
  type: FETCH_UNPLANNED_LOCATIONS,
  payload: { positions, activeOnly },
});

export const fetchUnplannedLocationsSuccess = (locations: any[]) => ({
  type: FETCH_UNPLANNED_LOCATIONS_SUCCESS,
  payload: locations,
});

export const fetchUnplannedLocationsFailure = (error: any) => ({
  type: FETCH_UNPLANNED_LOCATIONS_FAILURE,
  payload: error,
});

export const deleteHooAccommodation = (payload: any) => ({
  type: DELETE_HOO_REQUEST,
  payload,
});

export const deleteHooAccommodationSuccess = (payload: any) => ({
  type: DELETE_HOO_REQUEST_SUCCESS,
  payload,
});

export const deleteHooAccommodationFailure = (payload: any) => ({
  type: DELETE_HOO_REQUEST_FAILURE,
  payload,
});

export const acceptHooAccommodation = (payload: any) => ({
  type: ACCEPT_HOO_REQUEST,
  payload,
});

export const acceptHooAccommodationSuccess = (payload: any) => ({
  type: ACCEPT_HOO_REQUEST_SUCCESS,
  payload,
});

export const acceptHooAccommodationFailure = (payload: any) => ({
  type: ACCEPT_HOO_REQUEST_FAILURE,
  payload,
});

export const rejectHooAccommodation = (payload: any) => ({
  type: REJECT_HOO_REQUEST,
  payload,
});

export const rejectHooAccommodationSuccess = (payload: any) => ({
  type: REJECT_HOO_REQUEST_SUCCESS,
  payload,
});

export const rejectHooAccommodationFailure = (payload: any) => ({
  type: REJECT_HOO_REQUEST_FAILURE,
  payload,
});

export const SaveHooRequestSuccess = (payload: any) => ({
  type: SAVE_HOO_REQUEST_SUCCESS,
  payload,
});

export const SaveHooRequestFailed = (payload: any) => ({
  type: SAVE_HOO_REQUEST_FAILED,
  payload,
});

export const SaveHooAccommodation = (payload: any) => ({
  type: SAVE_HOO_REQUEST,
  payload,
});

export const fetchRequestReasons = (scheduleType: string) => ({
  type: FETCH_REQUEST_REASONS,
  payload: { scheduleType },
});

export const fetchRequestReasonsSuccess = (reasons: any[]) => ({
  type: FETCH_REQUEST_REASONS_SUCCESS,
  payload: reasons,
});

export const fetchRequestReasonsFailure = (error: any) => ({
  type: FETCH_REQUEST_REASONS_FAILURE,
  payload: error,
});

export const fetchRequestTypes = (scheduleType: string) => ({
  type: FETCH_REQUEST_TYPES,
  payload: { scheduleType },
});

export const fetchRequestTypesSuccess = (requestTypes: any[]) => ({
  type: FETCH_REQUEST_TYPES_SUCCESS,
  payload: requestTypes,
});

export const fetchRequestTypesFailure = (error: any) => ({
  type: FETCH_REQUEST_TYPES_FAILURE,
  payload: error,
});

export const exportHooRequests = (payload: any) => ({
  type: EXPORT_HOO_REQUESTS,
  payload,
});

export const exportHooRequestsSuccess = () => ({
  type: EXPORT_HOO_REQUESTS_SUCCESS,
});

export const exportHooRequestsFailure = (error: any) => ({
  type: EXPORT_HOO_REQUESTS_FAILURE,
  payload: error,
});
